













































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import Notification from "../general/Notification.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import CategoryTypeSelect from "../general/CategoryTypeSelect.vue";
import MailingsRecipientDetails from "./MailingsRecipientDetails.vue";
import MailingsListSelect from "./MailingsListSelect.vue";

import SettingsJson from "../../shared/SettingsJson";
import { ClientMailingJson, ClientMailingSelectableJson } from "../../shared/ClientJson";
import MailingRecipientJson from "../../shared/MailingRecipientJson";
import { MailingRecipientStatus, MailingRecipientStatusNames } from "../../shared/MailingRecipientStatus";
import MailingListJson from "../../shared/MailingListJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "MailingsRecipients",
  components: {
    Loading,
    Notification,
    OnscreenMenu,
    TableView,
    CategoryTypeSelect,
    MailingsListSelect,
    MailingsRecipientDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      MailingRecipientStatus: MailingRecipientStatus,
      MailingRecipientStatusNames: MailingRecipientStatusNames,
      CategoryTypeType: CategoryTypeType,
      showDetails: false,
      detailsMode: "read",
      categoryTypes: null as CategoryTypeJson[] | null,
      tableSelectable: false as boolean,
      useFilters: false as boolean,
      filterState: null as MailingRecipientStatus | null,
      filterListId: null as number | null,
      filterCategoryTypes: [] as number[],
      searchString: null as string | null,
      allMailingLists: null as MailingListJson[] | null,
      allRecipients: null as ClientMailingJson[] | null,
      allRecipientsSelectable: null as ClientMailingSelectableJson[] | null,
      recipientsMoreAvailable: null as boolean | null,
      selectedRecipientId: null as number | null,
      allSelectedRecipients: [] as ClientMailingSelectableJson[],
      showMailingListSelect: false as boolean,
      updateRecipientMailingListErrors: {} as { [index: string]: string },
      showNotificationMLSuccess: false,
      showNotificationMLError: false,
      loadingMailingList: false as boolean,
      rerenderTable: 0 as number,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: MailingRecipientJson | null, mode: string) {
      if (item != null) {
        this.selectedRecipientId = item.ID;
      } else {
        this.selectedRecipientId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadMailingLists();
      this.loadAllRecipients();
      this.loadCategoryTypes();
    },

    async loadMailingLists() {
      if (this.restClient != null) {
        try {
          this.allMailingLists = await this.restClient.getMailingLists();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadAllRecipients(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchString !== null) {
        if (loadMore == null) {
          this.allRecipients = null;
        }
        if (this.searchString == "") {
          this.searchString = null;
        }
      }

      var listId = null;
      var states = null;
      var typeIds = null;
      var skipAmount = null as number | null;

      //filters
      if (this.useFilters) {
        if (this.filterListId != null) {
          listId = this.filterListId;
        }

        if (this.filterState != null) {
          states = [this.filterState];
        }

        if (this.filterCategoryTypes.length > 0) typeIds = this.filterCategoryTypes;
      }

      //load more
      if (loadMore && this.allRecipients != null) {
        this.recipientsMoreAvailable = null;
        skipAmount = this.allRecipients.length;
      } else {
        this.allRecipients = null;
        this.allRecipientsSelectable = null;
      }

      //final load recipients
      if (this.restClient != null) {
        try {
          let recipients = await this.restClient.getMailingRecipients(
            states,
            listId,
            typeIds,
            this.searchString,
            skipAmount
          );

          if (loadMore && this.allRecipients != null && this.allRecipientsSelectable != null) {
            this.allRecipients = this.allRecipients.concat(recipients.mailingRecipients);

            //selectable
            recipients.mailingRecipients.forEach(
              (i: any) => (i.isSelected = this.allSelectedRecipients.find((j: any) => j.ID === i.ID) ? true : false)
            );
            this.allRecipientsSelectable = this.allRecipientsSelectable.concat(
              recipients.mailingRecipients as ClientMailingSelectableJson[]
            );
          } else {
            this.allRecipients = recipients.mailingRecipients;

            //selectable
            this.allRecipientsSelectable = JSON.parse(JSON.stringify(this.allRecipients));
            this.allRecipientsSelectable?.forEach(
              (i: any) => (i.isSelected = this.allSelectedRecipients.find((j: any) => j.ID === i.ID) ? true : false)
            );
          }

          this.recipientsMoreAvailable = recipients.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadCategoryTypes() {
      this.categoryTypes = null;

      try {
        this.categoryTypes = await this.restClient.getCategoryTypes();
      } catch (e) {
        alert(e.message);
      }
    },

    async reloadData() {
      this.loadAllRecipients();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllRecipients();
    },

    removeUseFilters() {
      this.useFilters = false;

      this.filterState = null;
      this.filterListId = null;
      this.filterCategoryTypes = [];
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllRecipients();
    },

    resetSearchString() {
      this.searchString = "";

      this.loadAllRecipients();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },

    async toggleSelectable() {
      this.tableSelectable = !this.tableSelectable;
      this.allSelectedRecipients = [];
      if (!this.tableSelectable) this.unselectAllRecipients();
    },

    selectRecipient(item: ClientMailingSelectableJson, selectState: boolean) {
      item.isSelected = selectState;

      if (selectState) {
        this.allSelectedRecipients.push(item);
      } else {
        let index = this.allSelectedRecipients.findIndex((i: any) => i.ID === item.ID);
        if (index > -1) {
          this.allSelectedRecipients.splice(index, 1);
        }
      }

      this.rerenderTable += 1;
    },

    selectAllRecipients() {
      if (this.allRecipientsSelectable != null) {
        for (let i of this.allRecipientsSelectable) {
          i.isSelected = true;
          if (!this.allSelectedRecipients.find((j: any) => j.ID === i.ID)) {
            this.allSelectedRecipients.push(i);
          }
        }

        this.rerenderTable += 1;
      }
    },

    unselectAllRecipients() {
      if (this.allRecipientsSelectable != null) {
        for (let i of this.allRecipientsSelectable) {
          i.isSelected = false;
          this.allSelectedRecipients = [];
        }

        this.rerenderTable += 1;
      }
    },

    toggleMailingListSelect() {
      this.showMailingListSelect = !this.showMailingListSelect;
    },

    async selectMailingList(mailingList: MailingListJson) {
      this.loadingMailingList = true;

      if (this.allSelectedRecipients && this.restClient != null) {
        for (let recipient of this.allSelectedRecipients) {
          const { isSelected, ...clientMailingRecipient } = recipient;

          if (
            clientMailingRecipient?.mailingRecipient?.mailingLists != null &&
            clientMailingRecipient.mailingRecipient.mailingLists.find(
              (i: MailingListJson) => i.ID == mailingList.ID
            ) === undefined
          ) {
            clientMailingRecipient.mailingRecipient.mailingLists.push(mailingList);

            await this.updateRecipientMailingList(clientMailingRecipient);
          }
        }
      }

      if (
        Object.keys(this.updateRecipientMailingListErrors).length === 0 &&
        this.updateRecipientMailingListErrors.constructor === Object
      ) {
        this.showNotificationMLSuccess = true;
      } else {
        this.showNotificationMLError = true;
      }

      this.tableSelectable = false;
      this.allRecipientsSelectable = null;
      this.allSelectedRecipients = [];
      this.loadingMailingList = false;
      this.reloadData();
    },

    async updateRecipientMailingList(recipient: ClientMailingJson) {
      if (recipient?.contact != null) {
        try {
          let updatedMemberDetails = await this.restClient.updateMailingRecipient(recipient);
        } catch (e) {
          this.updateRecipientMailingListErrors[recipient.contact.email] = e.message;
        }
      }
    },
  },

  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },

  computed: {
    recipientColumns: function (): TableViewColumnDefinitions<ClientMailingJson>[] {
      let vue = this;

      return [
        {
          th: "E-Mail",
          td: (i) => (i.contact != null && i.contact.email != "" ? i.contact.email : "--"),
        },
        {
          th: "Vorame",
          td: (i) => (i.contact != null && i.contact.firstName != "" ? i.contact.firstName : "--"),
        },
        {
          th: "Nachname",
          td: (i) => (i.contact != null && i.contact.lastName != "" ? i.contact.lastName : "--"),
        },
        {
          th: "Organisation",
          td: (i) => (i.contact != null && i.contact.organisation != "" ? i.contact.organisation : "--"),
        },
        {
          th: "Zugeordnete Listen",
          td: (i) => {
            let names = i.mailingRecipient!.mailingLists?.map((list) => list.name);
            return names ? names.join(", ") : "--";
          },
        },
        {
          th: "Kategorien",
          td: "",
          categoryLabel: (i) => i.types ?? [],
        },
        {
          th: "Status",
          td: (i) => vue.MailingRecipientStatusNames[i.mailingRecipient!.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<ClientMailingJson>[];
    },
  },
});
